﻿import React from 'react';
import Lottie from 'lottie-react';
import { animated, useSpring } from '@react-spring/web';

const NewAchievementItem = ({ description, animationData, index }) => {

    const ref = React.useRef();

    React.useEffect(() => {
        setTimeout(() => {
            if (ref && ref.current) {
                ref.current.play();
            }
        }, index * 1000 + 500)
    }, [ref, index]);

    const {c} = useSpring({
        config: {
            mass: 3,
            tension: 400,
            friction: 10,
            frequency: 3.5,
            damping: 1.5,
        },
        from: {
            c: 0,
        },
        c: 1,
        delay: index * 500 
    });


    return (
        <li className="my-pages-achievements__list__item">           
            <animated.div
                className="my-pages-achievements__list__item__text__container my-pages-achievements__list__item__text__container--new"
                style={{
                    background: c.to({
                        range: [0, .75, 1],
                        output: ['white', '#D1E9F9', 'white']
                    }).to(c => c)
                }}>
                <Lottie
                    className="my-pages-achievements__list__item__star my-pages-achievements__list__item__star--lottie"
                    lottieRef={ref}
                    autoplay={false}
                    loop={false}
                    animationData={animationData}
                />
                <p className="my-pages-achievements__list__item__text__container__description">{description}</p>
            </animated.div>
        </li>
     )
 }                

export default NewAchievementItem;